import { IServicePersons } from "../interfaces";
import { MAIDEN_ITEMS } from "./maidens-items";

export function getRomanPersons() {
	const output: Array<IServicePersons> = [];

	// kamosi
	output.push({
		group: "roman-kamosi",
		items: [
			{ key: "TOM_VOJ", fullName: "Tomáš Vojtíšek", nickName: "od Rudy", sex: "M", birthdate: "1996-08-08" },
			{ key: "DAV_VYM", fullName: "David Vymyslický", nickName: "Peťka", sex: "M", birthdate: "1998-08-02" },
			{ key: "DAV_VYM2", fullName: "David Vymyslický", nickName: "Grňa", sex: "M", birthdate: "1978-01-06" },
			{ key: "JIT_KOS", fullName: "Jitka Kosinová", sex: "F", birthdate: "1994-08-27" },
			{ key: "MIC_VYM", fullName: "Michal Vymyslický", nickName: "Kalič", sex: "M", birthdate: "1988-02-08" },
			{ key: "LUK_JAK", fullName: "Lukáš Jakůbek", nickName: "Kakáč", sex: "M", birthdate: "1991-03-01" },
			{ key: "ADA_JAK", fullName: "Adam Jakůbek", sex: "M", birthdate: "1994-09-16" },
			{ key: "MAR_BLA", fullName: "Martin Blaha", sex: "M", birthdate: "1988-07-27" },
			{ key: "ANE_KOM", fullName: "Aneta Komosná", sex: "F" },
			{ key: "JAN_OUH", fullName: "Jana Ouhrabková", sex: "F" },
			{ key: "MAR_MRK", fullName: "Marek Mrkva", sex: "M", birthdate: "1990-03-15" },
			{ key: "PAV_PUL", fullName: "Pavel Půlkrábek", nickName: "Pulec", sex: "M", birthdate: "1989-11-15" },
			{ key: "VER_PUL", fullName: "Veronika Půlkrábková", maidenItems: MAIDEN_ITEMS.VER_PUL, sex: "F", birthdate: "1990-09-11" },
			{ key: "ALE_TOM", fullName: "Aleš Tomáštík", sex: "M", birthdate: "1990-05-03" },
			{ key: "MAR_BAC", fullName: "Martin Bača", sex: "M", birthdate: "1993-02-11" },
			{ key: "PAV_BRA", fullName: "Pavel Bravenec", nickName: "Brčko", sex: "M", birthdate: "1990-08-31" },
			{ key: "PET_EST", fullName: "Petr Esterka", sex: "M", birthdate: "1991-08-05" },
			{ key: "VER_MAK", fullName: "Veronika Makuderová", maidenItems: MAIDEN_ITEMS.VER_MAK, sex: "F", birthdate: "1994-09-24" },
			{ key: "TER_PUR", fullName: "Tereza Purmenská", sex: "F", birthdate: "1997-02-09" },
			{ key: "MAR_RAC", fullName: "Martin Račický", sex: "M", birthdate: "1985-01-17" },
			{ key: "MIC_RAC", fullName: "Michal Račický", nickName: "Šusťák", sex: "M", birthdate: "1986-04-18" },
			{ key: "VIT_BIL", fullName: "Vít Bílek", nickName: "Wikki", sex: "M", birthdate: "1985-07-10" },
			{ key: "BED_VYM", fullName: "Bedřich Vymyslický", nickName: "Béďa", sex: "M", birthdate: "1981-07-16" },
			{ key: "HAN_DLA", fullName: "Hana Dlabajová", maidenItems: MAIDEN_ITEMS.HAN_DLA, sex: "F", birthdate: "1989-10-23" },
			{ key: "PAV_SLA", fullName: "Pavel Sládek", nickName: "Kulík", sex: "M", birthdate: "1980-06-18" },
			{ key: "EVA_NET", fullName: "Eva Netopilová", sex: "F", birthdate: "1990-10-19" },
			{ key: "MIC_PUR", fullName: "Michal Purmenský", sex: "M", birthdate: "1990-05-01" },
			{ key: "PET_PUR", fullName: "Petr Purmenský", sex: "M", birthdate: "1991-08-17" },
			{ key: "RAD_MRK", fullName: "Radek Mrkva", nickName: "Jesus", sex: "M", birthdate: "1982-06-15" },
			{ key: "JAN_MRK", fullName: "Jan Mrkva", info: "Jesus brácha", sex: "M", birthdate: "1980-05-25" },
			{ key: "ALE_REZ", fullName: "Aleš Řezáč", nickName: "Kalich", sex: "M", birthdate: "1990-01-02" },
			{ key: "HON_ZUG", fullName: "Honza Zugar", sex: "M", birthdate: "1987-04-06", calName: "Jan" },
			{ key: "DAV_STO", fullName: "David Stöhr", nickName: "Rakeťák", sex: "M", birthdate: "1990-01-20" },
			{ key: "STA_LEL", fullName: "Stanislav Lelka", nickName: "Stenly", sex: "M", birthdate: "1982-02-23" },
			{ key: "JAR_BUD", fullName: "Jaromír Budovič", sex: "M", birthdate: "1986-05-05" },
			{ key: "JAK_BAC", fullName: "Jakub Bača", nickName: "Tygr", sex: "M", birthdate: "1991-04-22" },
			{ key: "JAN_SPE", fullName: "Jana Spěváková", nickName: "Kalič", sex: "F", birthdate: "1981-09-10" },
			{ key: "MIR_LUK", fullName: "Miroslav Lukáč", sex: "M", birthdate: "1989-05-21" },
			{ key: "IVE_RAJ", fullName: "Iveta Rajchmanová", sex: "F", birthdate: "1994-03-24" },
			{ key: "KAT_LEL", fullName: "Kateřina Lelková", maidenName: ["Sejáková"], sex: "M", birthdate: "1991" },
			{ key: "MAR_STR", fullName: "Markéta Straková", nickName: "Makina", sex: "F", birthdate: "1988" },
			{ key: "MIC_BEL", fullName: "Michal Bělohlávek", sex: "M", birthdate: "1982-06-27" },
			{ key: "MAR_VAC", fullName: "Martin Vaculík", nickName: "Stárek", sex: "M", birthdate: "1990" },
			{ key: "DAN_KOL", fullName: "Daniel Koliba", nickName: "Don Beer", sex: "M", birthdate: "1990" },
			{ key: "MAR_CIZ", fullName: "Martin Čížek", nickName: "Žula", sex: "M", birthdate: "1990" },
			{ key: "MIL_REZ", fullName: "Milan Řezáč", nickName: "Milada", sex: "M", birthdate: "1982" },
			{ key: "PAV_VYM", fullName: "Pavel Vymyslický", nickName: "Kalič", sex: "M", birthdate: "1978-11-11" },
			{ key: "TOM_VYM", fullName: "Tomáš Vymyslický", nickName: "Dungaj", sex: "M", birthdate: "1983" },
			{ key: "VER_VYM", fullName: "Veronika Vymyslická", sex: "F", birthdate: "1985" },
			{ key: "KAT_SVO", fullName: "Kateřina Svobodová", info: "Souseda", sex: "F", birthdate: "1991-04-04" },
			{ key: "LUD_SEJ", fullName: "Ludmila Sejáková", sex: "F", birthdate: "1994" },
			{ key: "JAN_SEJ", fullName: "Jan Seják", sex: "M", birthdate: "1994" },
			{ key: "ROM_ZIM", fullName: "Roman Zimák", sex: "M", birthdate: "1986-05-25" },
			{ key: "ROB_ROB", fullName: "Robin Robča", sex: "M", birthdate: "1985" },
			{ key: "MIC_SIN", fullName: "Michaela Šindarová", maidenItems: MAIDEN_ITEMS.MIC_SIN, sex: "F", birthdate: "1991-07-02" },
			{ key: "RUZ_KUC", fullName: "Růžena Kučerová", sex: "F", birthdate: "1990-01-25" },
			{ key: "ANE_ROZ", fullName: "Aneta Rozehnalová", sex: "F", birthdate: "1990-10-10" },
			{ key: "MAR_VES2", fullName: "Martin Veselý", nickName: "Faba", sex: "M", birthdate: "1990" },
			{ key: "BAR_URB", fullName: "Barbora Urbanová", sex: "F", birthdate: "1992-08-18" },
			{ key: "MIC_SKO", fullName: "Michaela Školová", sex: "F", birthdate: "1994-12-11" },
			{ key: "LEN_CHM", fullName: "Lenka Chmelařová", sex: "F", birthdate: "1990" },
			{ key: "JAK_KOS", fullName: "Jakub Košutek", sex: "M", birthdate: "1992-04-04" },
			{ key: "KAT_KRA", fullName: "Kateřina Kramářová", info: "Od Vítka, blond", sex: "F", birthdate: "1991" },
			{ key: "MIL_SVE", fullName: "Milan Světnička", sex: "M", birthdate: "1991-02-23" },
			{ key: "STA_BOH", fullName: "Stanislav Bohůn", sex: "M", birthdate: "1990" },
			{ key: "MON_UHL", fullName: "Monika Uhlířová", info: "Saša", sex: "F", birthdate: "1990" },
			{ key: "DEN_PRI", fullName: "Denisa Příkopová", info: "Saša", sex: "F", birthdate: "1990" },
			{ key: "STA_RAJ", fullName: "Stanislav Rajchman", sex: "M", birthdate: "1985-12-04" },
			{ key: "RAD_BLA", fullName: "Radek Blaha", sex: "M", birthdate: "1991" },
			{ key: "JIR_BRA", fullName: "Jiří Bravenec", info: "Brčko brácha", sex: "M", birthdate: "1979-11-23" },
			{ key: "ROM_MAR", fullName: "Romana Martincová", info: "2010 zemřela", sex: "F", birthdate: "1991-09-28", deceased: "2010" },
			{ key: "MIR_RAJ", fullName: "Miroslava Rajchmanová", info: "Filip manželka", sex: "F", birthdate: "1990" },
			{ key: "VLA_BLA", fullName: "Vladimír Blaha", sex: "M", birthdate: "1988-10-18" },
			{ key: "ANT_KON", fullName: "Antonín Konečný", info: "Děti noci", sex: "M", birthdate: "1991" },
			{ key: "EVA_BIL", fullName: "Eva Bílíková", nickName: "Satan", sex: "F", birthdate: "1993-11-10" },
			{ key: "JAK_MRK", fullName: "Jakub Mrkva", sex: "M", birthdate: "1990" },
			{ key: "PET_HAS", fullName: "Petr Hasil", sex: "M", birthdate: "1982-06-24" },
			{ key: "FRA_SEJ", fullName: "František Seják", sex: "M", birthdate: "1989" },
			{ key: "RAD_SMR", fullName: "Radek Smrž", sex: "M", birthdate: "1989-06-22" },
			{ key: "MIC_BLA", fullName: "Michal Blaha", sex: "M", birthdate: "1988-08-14" },
			{ key: "FIL_CER", fullName: "Filip Červenka", sex: "M", birthdate: "1992-02-28" },
			{ key: "BAR_PAR", fullName: "Barbora Pardíková", sex: "F", birthdate: "1989-12-21" },
			{ key: "MAT_POL", fullName: "Matěj Polášek", sex: "M", birthdate: "1983-02-28" },
			{ key: "NIK_KUN", fullName: "Nikola Kundratová", sex: "F", birthdate: "1990-02-19" },
		],
	});

	// roman zakladka
	output.push({
		group: "roman-zakladka",
		items: [
			{ key: "SIM_BAK", fullName: "Simona Bakalová", maidenItems: MAIDEN_ITEMS.SIM_BAK, sex: "F", birthdate: "1987-09-29" },
			{ key: "ZAN_NOV", fullName: "Žaneta Nováková", sex: "F", birthdate: "1987-07-11" },
			{ key: "PAV_JAN", fullName: "Pavel Janů", nickName: "Kocůr", sex: "M", birthdate: "1987-09-10" },
			{ key: "MAR_FIA", fullName: "Martin Fiala", sex: "M", birthdate: "1987-11-03" },
			{ key: "LUC_ROB", fullName: "Lucie Robková", maidenItems: MAIDEN_ITEMS.LUC_ROB, sex: "F", birthdate: "1987" },
			{ key: "ZUZ_KRA", fullName: "Zuzana Krátká", maidenItems: MAIDEN_ITEMS.ZUZ_KRA, sex: "F", birthdate: "1987-11-02" },
			{ key: "JAR_STE", fullName: "Jarmila Štěpánková", maidenItems: MAIDEN_ITEMS.JAR_STE, sex: "F", birthdate: "1988-03-20" },
			{ key: "LEN_VYM", fullName: "Lenka Vymyslická", sex: "F", birthdate: "1987-11-10" },
			{ key: "MIR_PRI", fullName: "Miroslav Příkazský", nickName: "Zub", sex: "M", birthdate: "1988-02-17" },
			{ key: "LAD_VOJ", fullName: "Ladislav Vojáček", sex: "M", birthdate: "1987" },
			{ key: "MAR_SIM", fullName: "Marie Šimáková", sex: "F", birthdate: "1988-06-09" },
			{ key: "OND_MRK", fullName: "Ondřej Mrkva", sex: "M", birthdate: "1987-11-25" },
			{ key: "MAR_HUB", fullName: "Martin Hubáček", nickName: "Mista", sex: "M", birthdate: "1988-03-28" },
			{ key: "VLA_JAN", fullName: "Vlastimil Jansa", sex: "M", birthdate: "1963-10-13" },
			{ key: "MAR_DVO", fullName: "Marie Dvořáková", sex: "F", birthdate: "1945-10-26" },
			{ key: "BRO_SUP", fullName: "Bronislava Šuplerová", maidenName: ["Esterková"], sex: "F", calName: "Bronislav" },
			{ key: "JAR_SAL", fullName: "Jaroslava Salajková", maidenItems: MAIDEN_ITEMS.JAR_SAL, sex: "F", birthdate: "1987-09-04" },
			{ key: "OND_POS", fullName: "Ondřej Pospíšil", sex: "M", birthdate: "1988-07-05" },
			{ key: "VLA_PAV", fullName: "Vladimíra Pavková", sex: "F", calName: "Vladimír" },
			{ key: "MAR_MEC", fullName: "Marek Mečl", sex: "M", birthdate: "1988" },
			{ key: "MIR_KOM", fullName: "Miroslava Konečná", sex: "F", maidenName: ["Komosná"], birthdate: "1987-05-25" },
			{ key: "ROM_BIL", fullName: "Roman Bílek", sex: "M", birthdate: "1988-04-28" },
			{ key: "ALZ_BRA", fullName: "Alžběta Bravencová", sex: "F", birthdate: "1988-05-13" },
			{ key: "TOM_MAY", fullName: "Tomáš Mayer", sex: "M", birthdate: "1987" },
			{ key: "LUC_LEK", fullName: "Lucie Lekavá", sex: "F", birthdate: "1988" },
			{ key: "JAN_HAN", fullName: "Jana Hanáková", maidenItems: MAIDEN_ITEMS.JAN_HAN, sex: "F", birthdate: "1988-04-01" },
			{ key: "ANN_BAB", fullName: "Anna Bábíková", sex: "F", birthdate: "1987" },
			{ key: "MAG_BIL", fullName: "Magdaléna Bílková", sex: "F", birthdate: "1987" },
			{ key: "PET_SPA", fullName: "Petra Špačková", sex: "F", birthdate: "1987" },
			{ key: "RAD_BER", fullName: "Radomír Berg", info: "Včetně 7. třídy", sex: "M", birthdate: "1987" },
			{ key: "PAV_BAC", fullName: "Pavel Bača", sex: "M", birthdate: "1987-12-31" },
			{ key: "PET_SAL", fullName: "Petr Salajka", sex: "M", birthdate: "1987" },
			{ key: "MON_BIL", fullName: "Monika Bílková", sex: "F", birthdate: "1988" },
			{ key: "JIR_SMA", fullName: "Jiří Šmach", sex: "M", birthdate: "1986" },
			{ key: "IRE_BER", fullName: "Irena Bergová", info: "Třídní", sex: "F" },
			{ key: "BOZ_BOL", fullName: "Božena Bolfíková", info: "Třídní", sex: "F" },
			{ key: "HAN_HAN", fullName: "Hana Hanousková", sex: "F", deceased: "2004" },
			{ key: "PET_KAR", fullName: "Petr Karas", info: "Farář", sex: "M", birthdate: "1969" },
			{ key: "VIT_NAV", fullName: "Vítězslav Navrátil", sex: "M" },
			{ key: "VLA_POL", fullName: "Vladimír Polínek", info: "Třídní", sex: "M", deceased: "2006" },
			{ key: "ALE_ZEM", fullName: "Alena Zemanová", sex: "F" },
			{ key: "ZDE_MLY", fullName: "Zdeněk Mlýnek", info: "Bývalý ředitel", sex: "M", birthdate: "1942", deceased: "2006" },
			{ key: "MAR_ZAL", fullName: "Marie Zálešáková", sex: "F" },
		],
	});

	// roman stredni
	output.push({
		group: "roman-stredni",
		items: [
			{ key: "JAN_BAR", fullName: "Jan Bartocha", nickName: "Loki", sex: "M" },
			{ key: "VIT_HLA", fullName: "Vít Hlaváč", sex: "M", birthdate: "1987-07-16" },
			{ key: "ADA_KRA", fullName: "Adam Kratochvíl", nickName: "Mrťa", sex: "M", birthdate: "1987-11-16" },
			{ key: "ROM_KON", fullName: "Roman Konečný", sex: "M", birthdate: "1988" },
			{ key: "ROM_MOR", fullName: "Roman Morávek", sex: "M", birthdate: "1987-09-24" },
			{ key: "MIC_KAD", fullName: "Michal Kadlec", sex: "M", birthdate: "1988-04-25" },
			{ key: "LAD_NAV", fullName: "Ladislav Navrátil", sex: "M", birthdate: "1988-02-25" },
			{ key: "PET_MIK", fullName: "Petr Mikulica", sex: "M", birthdate: "1988-01-17" },
			{ key: "MAR_SOT", fullName: "Marek Šottl", sex: "M", birthdate: "1988-02-21" },
			{ key: "MAR_VEV", fullName: "Martin Veverka", sex: "M", birthdate: "1988-05-17" },
			{ key: "PAV_STA2", fullName: "Pavel Staňa", sex: "M", birthdate: "1988-02-06" },
			{ key: "STA_CRH", fullName: "Stanislav Crhák", sex: "M", birthdate: "1988-02-19" },
			{ key: "MAR_STI", fullName: "Martin Stiburek", sex: "M" },
			{ key: "JAN_KOV", fullName: "Jana Kovářová", sex: "F", birthdate: "1987-10-08" },
			{ key: "BAR_KAH", fullName: "Barbora Kahounová", sex: "F", birthdate: "1988-03-08" },
			{ key: "LUK_JAN", fullName: "Lukáš Janda", sex: "M", birthdate: "1988-03-03" },
			{ key: "KAM_MAJ", fullName: "Kamil Majer", sex: "M" },
			{ key: "JIR_MAL", fullName: "Jiří Maleček", sex: "M" },
			{ key: "MAR_POS", fullName: "Martin Pospíšil", sex: "M" },
			{ key: "PAV_BEN", fullName: "Pavel Benáček", sex: "M" },
			{ key: "LUK_VOZ", fullName: "Lukáš Vozdecký", sex: "M", birthdate: "1987-11-19" },
			{ key: "MAR_MLY", fullName: "Martin Mlýnek", sex: "M", birthdate: "1989-06-06" },
			{ key: "JAN_KOV2", fullName: "Jan Kovacs", sex: "M" },
			{ key: "PET_TRA", fullName: "Petr Trávník", sex: "M" },
			{ key: "LUB_MAT", fullName: "Lubomír Maťák", sex: "M", birthdate: "1986-08-07" },
			{ key: "ALE_UNG", fullName: "Aleš Unger", sex: "M" },
			{ key: "JOS_MUS", fullName: "Josef Musil", sex: "M" },
			{ key: "PAV_RIH", fullName: "Pavel Říhák", nickName: "Řepa", sex: "M", birthdate: "1987-09-05" },
			{ key: "MIR_GER", fullName: "Miroslav Geršic", info: "Třídní", sex: "M", birthdate: "1944-07-18" },
			{ key: "VIM_ZAV", fullName: "Vilém Závodný", info: "Elektro", sex: "M", birthdate: "1967-02-13" },
			{ key: "MAR_MAT", fullName: "Marcela Matušková", info: "Matika", sex: "M", birthdate: "1976-09-27" },
			{ key: "ZDE_SOL", fullName: "Zdena Soldánová", info: "Chemie", sex: "M" },
			{ key: "KAM_KOS", fullName: "Kamila Koštuříková", info: "Elektro", sex: "M" },
			{ key: "LUC_BAT", fullName: "Lucie Baťková", info: "Fyzika", sex: "M" },
			{ key: "REN_OTR", fullName: "Renáta Otrhalíková", info: "Ekonomie", sex: "M" },
			{ key: "FRA_NOS", fullName: "František Nosterský", info: "Elektro", sex: "M" },
			{ key: "JIR_BEL", fullName: "Jiří Bělík", sex: "M" },
			{ key: "JAR_UHL", fullName: "Jarmila Uhlířová", sex: "M" },
			{ key: "PAV_NOZ", fullName: "Pavel Nožička", info: "Knihovna", sex: "M", birthdate: "1979-04-14" },
			{ key: "DAV_KOL", fullName: "David Kolník", info: "Dava", sex: "M" },
		],
	});

	// roman vut
	output.push({
		group: "roman-vut",
		items: [
			{ key: "RAM_OMA", fullName: "Rami Al-Omari", nickName: "Rami", sex: "M", birthdate: "1987-05-28", calName: "Anděla" },
			{ key: "JAK_ADA", fullName: "Jakub Adámek", sex: "M", birthdate: "1989-02-18" },
			{ key: "HON_BAR", fullName: "Honza Bartoň", sex: "M", birthdate: "1987", calName: "Jan" },
			{ key: "PET_ALT", fullName: "Peter Altamirano", sex: "M", birthdate: "1988-03-17", calName: "Petr" },
			{ key: "KAR_ALT", fullName: "Karol Altamirano", sex: "M", birthdate: "1989", calName: "Karel" },
			{ key: "JAN_SCH", fullName: "Jan Schovánek", sex: "M", birthdate: "1987-09-03" },
			{ key: "RAD_FRY", fullName: "Radek Fryšták", sex: "M", birthdate: "1986-09-18" },
			{ key: "PET_BET", fullName: "Peter Beťko", sex: "M", birthdate: "1988", calName: "Petr" },
			{ key: "JAK_DAV", fullName: "Jakub David", sex: "M", birthdate: "1988-06-07" },
			{ key: "DAV_HUS", fullName: "David Húšťava", sex: "M", birthdate: "1988-10-23" },
		],
	});

	// roman ostrava
	output.push({
		group: "roman-banska",
		items: [
			{ key: "LUK_HUF", fullName: "Lukáš Huf", sex: "M", birthdate: "1985" },
			{ key: "ROM_REC", fullName: "Romana Rechová", sex: "F", birthdate: "1987-09-15" },
		],
	});

	// netdirect
	output.push({
		group: "roman-netdirect",
		items: [
			{ key: "OND_ZDY", fullName: "Ondřej Ždych", sex: "M", birthdate: "1988-01-28" },
			{ key: "TER_ZDY", fullName: "Tereza Ždychová", maidenItems: MAIDEN_ITEMS.TER_ZDY, sex: "F", birthdate: "1989" },
			{ key: "ZUZ_HAL", fullName: "Zuzana Haltufová", sex: "F", birthdate: "1985-02-03" },
			{ key: "PAV_STA", fullName: "Pavel Starzyczny", nickName: "Stařo", sex: "M", birthdate: "1987-07-07" },
			{ key: "MAR_MAG", fullName: "Marek Magdziak", sex: "M", birthdate: "1990-10-14" },
			{ key: "ROB_GOR", fullName: "Robert Gorba", sex: "M", birthdate: "1970-05-26" },
			{ key: "KAR_DUS", fullName: "Karel Dušík", sex: "M", birthdate: "1978-06-29" },
			{ key: "VLA_GRA", fullName: "Vladimír Grác", sex: "M", birthdate: "1984-11-25" },
			{ key: "PAV_KRA", fullName: "Pavel Kramný", info: "CEO", sex: "M", birthdate: "1974-12-17" },
			{ key: "KAT_SPA", fullName: "Kateřina Spáčilová", sex: "F", birthdate: "1976-06-23" },
			{ key: "TOM_MUS", fullName: "Tomáš Musiol", sex: "M", birthdate: "1983-03-30" },
			{ key: "OND_MAC", fullName: "Ondřej Machala", sex: "M", birthdate: "1987-07-05" },
			{ key: "BAR_HRE", fullName: "Barbora Hrebeňárová", sex: "F", birthdate: "1973" },
			{ key: "DAN_REZ", fullName: "Daniel Řezníček", sex: "M", birthdate: "1971-05-11" },
			{ key: "RAD_DYB", fullName: "Radka Dybowicz", info: "Za mlada?", sex: "F", birthdate: "1984-08-17" },
			{ key: "MIC_SLA", fullName: "Michaela Sládková", sex: "F", birthdate: "1990-07-17" },
			{ key: "MIC_CIC", fullName: "Michal Čičkán", sex: "M", birthdate: "1989-09-07" },
			{ key: "MIL_VON", fullName: "Milada Vontorová", sex: "F", birthdate: "1973-04-19" },
			{ key: "LUK_SIM", fullName: "Lukáš Šimeček", sex: "M", birthdate: "1983" },
			{ key: "VLA_VAV", fullName: "Vladimír Vavřík", sex: "M", birthdate: "1988" },
			{ key: "PET_VRB", fullName: "Peter Vrba", info: "Apple", sex: "M", birthdate: "1989-12-08", calName: "Petr" },
			{ key: "TOM_BED", fullName: "Tomáš Bednár", info: "Brýle", sex: "M", birthdate: "1986" },
			{ key: "LUB_STY", fullName: "Lubomír Stýskala", sex: "M", birthdate: "1982-05-10" },
			{ key: "PET_JAN", fullName: "Peter Janák", sex: "M", birthdate: "1989-09-25", calName: "Petr" },
			{ key: "RAD_BAN", fullName: "Radim Bančkovski", sex: "M", birthdate: "1979" },
			{ key: "DAV_BLA", fullName: "David Blahut", sex: "M", birthdate: "1977-04-12" },
			{ key: "PET_DVO", fullName: "Petr Dvořák", sex: "M", birthdate: "1984" },
			{ key: "PET_OTA", fullName: "Petr Otáhal", sex: "M", birthdate: "1964-05-11" },
			{ key: "ZUZ_FUK", fullName: "Zuzana Fuksová", info: "Testerka", sex: "F", birthdate: "1982-10-28" },
			{ key: "JIR_KOM", fullName: "Jiří Komár", info: "SEO", sex: "M", birthdate: "1985-09-28" },
			{ key: "MIC_SLO", fullName: "Michal Sloviak", sex: "M", birthdate: "1982-09-23" },
			{ key: "LUD_STI", fullName: "Luděk Štípala", info: "Kokot", sex: "M", birthdate: "1982" },
			{ key: "ROM_DOR", fullName: "Roman Dorník", info: "Můj šéf Dodo", sex: "M", birthdate: "1969-12-02" },
			{ key: "MAR_STA", fullName: "Martina Staňková", sex: "F", maidenName: ["Hudečková"], birthdate: "1985-04-26" },
			{ key: "OND_GAS", fullName: "Ondřej Gašpar", sex: "M", birthdate: "1988-03-28" },
		],
	});

	// mautilus
	output.push({
		group: "roman-mautilus",
		items: [
			{ key: "ROM_HOS", fullName: "Roman Hošek", sex: "M", birthdate: "1986-12-14" },
			{ key: "VIT_KAT", fullName: "Vít Katolický", sex: "M", birthdate: "1986-05-16" },
			{ key: "REH_VYK", fullName: "Řehoř Vykoupil", info: "CEO", sex: "M", birthdate: "1976-05-11" },
			{ key: "PET_MAZ", fullName: "Petr Mazanec", sex: "M", birthdate: "1981-01-29" },
			{ key: "IVA_BRA", fullName: "Ivan Bradáč", sex: "M", birthdate: "1968-03-02" },
			{ key: "SIM_POG", fullName: "Simone Poggiali", sex: "M", birthdate: "1980-01-21", calName: "Šimon" },
			{ key: "PET_PRE", fullName: "Petr Přerovský", sex: "M", birthdate: "1987" },
			{ key: "MAT_MAI", fullName: "Matěj Mainuš", sex: "M", birthdate: "1991-01-21" },
			{ key: "MIC_RUM", fullName: "Michael Ruml", sex: "M", birthdate: "1991-11-08", calName: "Michal" },
			{ key: "DAN_STR", fullName: "Daniel Štreit", sex: "M", birthdate: "1976-02-26" },
			{ key: "DAN_REG", fullName: "Daniel Regeci", sex: "M", birthdate: "1988-03-28" },
			{ key: "DAN_VRA", fullName: "Daniel Vrátil", sex: "M", birthdate: "1987-05-20" },
			{ key: "MIL_MOU", fullName: "Milan Moučka", sex: "M", birthdate: "1986" },
			{ key: "TOM_STR", fullName: "Tomáš Štrigner", sex: "M", birthdate: "1985-01-23" },
		],
	});

	// ostatni
	output.push({
		group: "roman-ostatni",
		items: [
			{ key: "PRA_PRC", fullName: "Pravomil Prchal", nickName: "Pravek007", sex: "M", birthdate: "1992-10-02", calName: "Vincenc" },
			{ key: "JAN_SLA", fullName: "Jan Slavinger", nickName: "Bcgroi", sex: "M", birthdate: "1991-11-22" },
			{ key: "VOJ_POD", fullName: "Vojtěch Podolák", sex: "M", birthdate: "1993-07-08" },
			{ key: "PET_LIG", fullName: "Petr Ligas", sex: "M", birthdate: "1991-08-27" },
			{ key: "TER_BUS", fullName: "Tereza Buštová", sex: "F", birthdate: "1993-06-24", info: "Nevím datum" },
			{ key: "KLA_BUS", fullName: "Klára Buštová", sex: "F" },
			{ key: "MAR_MAL", fullName: "Martin Malý", sex: "M", birthdate: "1992-09-29", nickName: "Ati" },
			{ key: "PET_SOC", fullName: "Petr Sochor", sex: "M", info: "Dlouhé černé vlasy" },
			{ key: "DAV_BUM", fullName: "David Bumbálek", sex: "M", info: "Velitel DC" },
			{ key: "PAV_KOL2", fullName: "Pavel Kolář", sex: "M", info: "Krátké vlasy, armáda spásy" },
			{ key: "JAN_VOT", fullName: "Jan Votava", sex: "M", info: "Bradka" },
			{ key: "ALE_SVO", fullName: "Alexandr Svoboda", sex: "M", info: "Malý" },
			{ key: "JAN_RUB", fullName: "Jan Rubeš", sex: "M", birthdate: "1987-12-24" },
		],
	});

	return output;
}
